/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceNowIncidentManagementCustomFieldValueMapping {
    getFixupPrototypeFunction() { return ServiceNowIncidentManagementCustomFieldValueMapping.fixupPrototype; }

    static newInstance(model: Partial<ServiceNowIncidentManagementCustomFieldValueMapping>): ServiceNowIncidentManagementCustomFieldValueMapping {
        let obj = Object.assign(new ServiceNowIncidentManagementCustomFieldValueMapping(), model);
        ServiceNowIncidentManagementCustomFieldValueMapping.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceNowIncidentManagementCustomFieldValueMapping>): ServiceNowIncidentManagementCustomFieldValueMapping {
        if (!model) return null;
        return ServiceNowIncidentManagementCustomFieldValueMapping.newInstance(<ServiceNowIncidentManagementCustomFieldValueMapping> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceNowIncidentManagementCustomFieldValueMapping) {
        if (!obj) return;

        models.ServiceNowIncidentManagementCustomFieldValueMapping.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceNowIncidentManagementCustomFieldValueMapping): boolean {
        Object.setPrototypeOf(obj, ServiceNowIncidentManagementCustomFieldValueMapping.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Value for Mapping field
     */
    value: string;

    /**
     * Actual value to use instead value
     */
    actual_value: string;

}
